import type { JSX, ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { useT } from '@/i18n/language'

/**
 * Une URL collée ne doit pas contourner la capacité qui a retiré une entrée de navigation.
 * Le contenu métier n'est volontairement jamais monté dans le cas refusé : cela évite les
 * données fugitives et les erreurs HTTP brutes qui distingueraient une ressource protégée.
 */
export function RouteAccessGuard({ allowed, reason, children }: {
  allowed: boolean
  reason: string
  children: ReactNode
}): JSX.Element {
  const { t } = useT()
  if (allowed) return <>{children}</>
  // Le refus REMPLACE l'écran (route entière, ou page du niveau Plateforme) : son titre est le
  // titre de la page, donc un `h1` — un `<p>` laissait chaque refus sans aucun titre
  // (AUD-CRAWL-P11 : 16 routes du propriétaire, 27 du lecteur). La classe garde l'apparence de l'état.
  return (
    <section className="state state--error" role="alert" aria-label={t('acces.restreint', 'Accès restreint')} data-testid="route-access-denied">
      <h1 className="state__title">{t('acces.restreint', 'Accès restreint')}</h1>
      <p className="state__hint">{reason}</p>
      <Link className="button" to="/">{t('acces.retourTableauDeBord', 'Retour au tableau de bord')}</Link>
    </section>
  )
}
